module.exports = __webpack_public_path__ + "img/fail.4067ea27.svg";